import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSavedFilters as GetSavedFiltersQuery,
    GetSavedFiltersVariables as GetSavedFiltersQueryVariables,
    GetSavedFilters_savedFilters_edges_node as SavedFilter,
} from 'nutshell-graphql-types';

import GET_SAVED_FILTERS from '../queries/get-saved-filters.graphql';

export const useGetSavedFilters = (
    variables: GetSavedFiltersQueryVariables
): {
    savedFilters: SavedFilter[];
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const {data, error, loading} = useQuery<GetSavedFiltersQuery, GetSavedFiltersQueryVariables>(
        GET_SAVED_FILTERS,
        {
            variables,
            fetchPolicy: 'cache-and-network',
        }
    );

    const savedFilters = data ? data.savedFilters.edges.map((edge) => edge.node) : [];

    return {
        savedFilters: savedFilters,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
